import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ExecuteDynamicActionsBrickUserActions } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/dynamic-actions-behavior/dynamic-actions-behavior.actions';
import { DynamicActionsBehaviorStateButtonsSelectors } from 'src/app/store/dashboard/brick-wall/brick-behaviour-state/brickTypes/dynamic-actions-behavior/dynamic-actions-behavior.buttons.selectors';
import { DynamicActionEvent } from '../../dynamic-action-button/dynamic-action-button.component';
import { IDynamicActionsBrickEntry } from '../../dynamic-actions-brick-configuration/dynamic-actions-brick-configuration';
import { IDynamicActionsBrickLayoutComponent } from '../i-dynamic-actions-brick-layout-component';

@Component({
   selector: 'samweb-dynamic-actions-brick-buttons-layout',
   templateUrl: './dynamic-actions-brick-buttons-layout.component.html',
   styleUrls: ['./dynamic-actions-brick-buttons-layout.component.scss'],
})
export class DynamicActionsBrickButtonsLayoutComponent implements IDynamicActionsBrickLayoutComponent, OnInit {
   public brickInstanceId: Readonly<string>;
   public entries$: Observable<IDynamicActionsBrickEntry[]>;
   public selectionMode$: Observable<'single' | 'multiple'>;
   public orientation$: Observable<'column' | 'row'>;
   public toggleable$: Observable<boolean>;

   constructor(private store: Store) {}

   ngOnInit(): void {
      this.entries$ = this.store.select(DynamicActionsBehaviorStateButtonsSelectors.getSpecificButtons).pipe(map((fn) => fn(this.brickInstanceId)));

      this.selectionMode$ = this.store.select(DynamicActionsBehaviorStateButtonsSelectors.getSpecificSelectionMode).pipe(map((fn) => fn(this.brickInstanceId)));

      this.orientation$ = this.store.select(DynamicActionsBehaviorStateButtonsSelectors.getSpecificOrientation).pipe(map((fn) => fn(this.brickInstanceId)));

      this.toggleable$ = this.store.select(DynamicActionsBehaviorStateButtonsSelectors.getIsActionTogglable).pipe(map((fn) => fn(this.brickInstanceId)));
   }

   dynamicActionClick(event: DynamicActionEvent) {
      if (event.isToggled && event.isTogglable) {
         this.store.dispatch(new ExecuteDynamicActionsBrickUserActions(event.actionEntry.undoActions));
         return;
      }
      this.store.dispatch(new ExecuteDynamicActionsBrickUserActions(event.actionEntry.actions));
   }
}
